import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { api } from "@/lib/api";

export const TemplatePrompt = () => {
  const [pending, setPending] = useState(null);

  useEffect(() => {
    Promise.all([api.get("/panels"), api.get("/options")])
      .then(([p, o]) => {
        const ready = new Set(p.data.filter((x) => (x.parameters || []).length).map((x) => x.test_name));
        setPending((o.data.test_name || []).filter((t) => !ready.has(t)));
      })
      .catch(() => setPending([]));
  }, []);

  if (!pending || pending.length === 0) return null;

  return (
    <div className="mt-6 rounded-md border border-[#B45309]/40 bg-[#FFFBEB] p-4 flex flex-wrap items-center gap-3"
      data-testid="template-prompt">
      <ClipboardList className="h-5 w-5 text-[#B45309]" />
      <div className="min-w-0">
        <p className="text-sm font-medium text-[#111827]">
          {pending.length} test{pending.length > 1 ? "s" : ""} still need a result template
        </p>
        <p className="text-xs text-[#6B7280] mt-0.5 truncate">
          Upload one of your past reports for {pending.slice(0, 4).join(", ")}
          {pending.length > 4 ? ` and ${pending.length - 4} more` : ""} — LabTrack reads the parameters, units and
          critical limits and uses them in every sample entry.
        </p>
      </div>
      <Link to="/templates" data-testid="template-prompt-link"
        className="ml-auto inline-flex items-center h-9 px-4 rounded-md bg-[#002FA7] hover:bg-[#00237C] text-white text-sm">
        Set up templates
      </Link>
    </div>
  );
};
